"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRequirementValidationResultDto = instanceOfRequirementValidationResultDto;
exports.RequirementValidationResultDtoFromJSON = RequirementValidationResultDtoFromJSON;
exports.RequirementValidationResultDtoFromJSONTyped = RequirementValidationResultDtoFromJSONTyped;
exports.RequirementValidationResultDtoToJSON = RequirementValidationResultDtoToJSON;
exports.RequirementValidationResultDtoToJSONTyped = RequirementValidationResultDtoToJSONTyped;
const FailureType_1 = require("./FailureType");
const WarningDto_1 = require("./WarningDto");
const RequirementValidationResultDtoFailingProps_1 = require("./RequirementValidationResultDtoFailingProps");
const RequirementName_1 = require("./RequirementName");
/**
 * Check if a given object implements the RequirementValidationResultDto interface.
 */
function instanceOfRequirementValidationResultDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('passed' in value) || value['passed'] === undefined)
        return false;
    return true;
}
function RequirementValidationResultDtoFromJSON(json) {
    return RequirementValidationResultDtoFromJSONTyped(json, false);
}
function RequirementValidationResultDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': (0, RequirementName_1.RequirementNameFromJSON)(json['name']),
        'passed': json['passed'],
        'notApplicable': json['notApplicable'] == null ? undefined : json['notApplicable'],
        'failureMessage': json['failureMessage'] == null ? undefined : json['failureMessage'],
        'failureType': json['failureType'] == null ? undefined : (0, FailureType_1.FailureTypeFromJSON)(json['failureType']),
        'warnings': json['warnings'] == null ? undefined : (json['warnings'].map(WarningDto_1.WarningDtoFromJSON)),
        'failingProps': json['failingProps'] == null ? undefined : (0, RequirementValidationResultDtoFailingProps_1.RequirementValidationResultDtoFailingPropsFromJSON)(json['failingProps']),
    };
}
function RequirementValidationResultDtoToJSON(json) {
    return RequirementValidationResultDtoToJSONTyped(json, false);
}
function RequirementValidationResultDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': (0, RequirementName_1.RequirementNameToJSON)(value['name']),
        'passed': value['passed'],
        'notApplicable': value['notApplicable'],
        'failureMessage': value['failureMessage'],
        'failureType': (0, FailureType_1.FailureTypeToJSON)(value['failureType']),
        'warnings': value['warnings'] == null ? undefined : (value['warnings'].map(WarningDto_1.WarningDtoToJSON)),
        'failingProps': (0, RequirementValidationResultDtoFailingProps_1.RequirementValidationResultDtoFailingPropsToJSON)(value['failingProps']),
    };
}
//# sourceMappingURL=RequirementValidationResultDto.js.map